module.exports = __webpack_public_path__ + "img/pressure.d7250923.svg";